import React, {useEffect} from 'react'
import classes from '../css/Footer.module.css'
import { FiFacebook ,FiLinkedin,FiMail} from 'react-icons/fi'
import styled from 'styled-components'
import Aos from 'aos'
import "aos/dist/aos.css"
import googleplay from './../../assets/pngegg.png';
import { contactUs } from '../../Config/Config'

const IconContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 40px;
    height: 40px;
    background-color: gray;
    border-radius: 10px;
    margin: 7px;
    transition: transform 0.2s ease;
    &:hover{
       transform: scale(1.1);
    }
`


export const Footer: React.FC = () => {
    useEffect(()=>{
        Aos.init({duration: 900, once: false})

    },[])
    return (
    <footer className={classes.Footer} id="footer" >
     <div className={'w-100 d-flex justify-content-between align-items-center   '}  data-aos="fade-up" data-aos-anchor-placement="top-bottom" >
         <div className={"px-3 d-flex"}>
             <IconContainer onClick={()=>window.open('https://www.facebook.com/sadatcityjobs')}><FiFacebook size={25} fontWeight={'200'} color={'black'}/></IconContainer>
             <IconContainer onClick={()=>window.open('https://www.linkedin.com/company/sadatcityjobs/')}><FiLinkedin size={25} fontWeight={'200'} color={'black'}/></IconContainer>
             <IconContainer onClick={()=>{ window.open(`mailto:${contactUs}`, "_blank")}}><FiMail size={25} fontWeight={'200'} color={'black'}/></IconContainer>


         </div>

          <div className={classes.googleplay + " px-3"}   onClick={()=>window.open('https://play.google.com/store/apps/details?id=com.sadatcityjobs')}>
            <img src={googleplay} alt={"sadatcityjobs"}/>
          </div>


     </div>
        <p className={'p-0 m-0'}>© 2022 Copyright sadatcityjobs.com</p>
    </footer>
    )
}